/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import DateFnsUtils from '@date-io/date-fns';
// @ts-expect-error todo(flow->ts) DateIOAdapter types is not exactly correct
var adapter = new DateFnsUtils({});
export default adapter;